export const addImgSizeToUrl = (url: string, size: number) => {
    if (url?.toString().includes("imagedelivery.net")) {
        return url + '/' + size.toString();
    } else {
        return url;
    }
}